'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.withCalls = withCalls;
exports.callProp = callProp;
exports.anyCallProp = anyCallProp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _nestedHateoas = require('@unitedtraders/nested-hateoas');

var _MethodType = require('@unitedtraders/nested-hateoas/dist/rpc/MethodType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(component) {
    return component.displayName || component.name || 'Component';
};

var CALL_METHOD_NAME_REGEXP = /([a-zA-Z0-9]+)\.([a-zA-Z0-9]+)\.([a-zA-Z0-9]+)/;

function validateCallMethodName(callName) {
    _auroraJavascriptUtils.assert.string(callName);

    if (!CALL_METHOD_NAME_REGEXP.test(callName)) {
        throw new Error('wrong call method name \'' + callName + '\'');
    };
}

function splitCallMethod(callName) {
    var _assert$string$split = _auroraJavascriptUtils.assert.string(callName).split('.'),
        _assert$string$split2 = _slicedToArray(_assert$string$split, 3),
        domainName = _assert$string$split2[0],
        serviceName = _assert$string$split2[1],
        methodName = _assert$string$split2[2];

    return { domainName: domainName, serviceName: serviceName, methodName: methodName };
}

/**
 *
 * @param {string} callDescriptor.method
 * @param {function?} callDescriptor.requestFactory
 * @param {function?} callDescriptor.isCallUpdateRequired
 * @param {function?} callDescriptor.onSuccess
 * @param {function?} callDescriptor.onFailure
 * @param {boolean?} callDescriptor.resetAfterSuccess
 */
function validateCallDescriptor(callDescriptor) {
    validateCallMethodName(callDescriptor.method);

    if (callDescriptor.requestFactory) {
        _auroraJavascriptUtils.assert.func(callDescriptor.requestFactory);
    }

    if (callDescriptor.isCallUpdateRequired) {
        _auroraJavascriptUtils.assert.func(callDescriptor.isCallUpdateRequired);
    }

    if (callDescriptor.onSuccess) {
        _auroraJavascriptUtils.assert.func(callDescriptor.onSuccess);
    }

    if (callDescriptor.onFailure) {
        _auroraJavascriptUtils.assert.func(callDescriptor.onFailure);
    }

    if (callDescriptor.resetAfterSuccess) {
        _auroraJavascriptUtils.assert.bool(callDescriptor.resetAfterSuccess);
    }
}

function validateCallDescriptors(callDescriptors) {
    _auroraJavascriptUtils.assert.object(callDescriptors);
    if (Object.keys(callDescriptors).length < 1) {
        throw new Error('pass at least one call');
    }

    Object.values(callDescriptors).forEach(validateCallDescriptor);
}

/**
 * build call from call descriptors and pass it as props to BaseComponent
 */
function withCalls(callDescriptors) {
    validateCallDescriptors(callDescriptors);

    var callNames = Object.keys(callDescriptors);

    return function (BaseComponent) {
        var WithApplication = function (_Component) {
            _inherits(WithApplication, _Component);

            function WithApplication() {
                var _ref;

                var _temp, _this, _ret;

                _classCallCheck(this, WithApplication);

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithApplication.__proto__ || Object.getPrototypeOf(WithApplication)).call.apply(_ref, [this].concat(args))), _this), _this.state = { calls: {} }, _temp), _possibleConstructorReturn(_this, _ret);
            }

            _createClass(WithApplication, [{
                key: 'componentWillMount',
                value: function componentWillMount() {
                    var _this2 = this;

                    var calls = callNames.reduce(function (result, callName) {
                        return _extends({}, result, _defineProperty({}, callName, _this2.buildCall(callDescriptors[callName], _this2.props)));
                    }, {});

                    var queries = Object.keys(calls).filter(function (callName) {
                        return calls[callName].methodDescriptor.methodType === _MethodType.MethodType.QUERY;
                    }).reduce(function (result, callName) {
                        var method = callDescriptors[callName].method;

                        return _extends({}, result, _defineProperty({}, method, [].concat(_toConsumableArray(result[method] || []), [callName])));
                    }, {});

                    this.setState({ calls: calls, queries: queries });

                    this._callQueriesListener = function (method) {
                        return _this2._callQueries(method);
                    };
                    this.context.utApplication.on('callQuery', this._callQueriesListener);
                }
            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.context.utApplication.off('callQuery', this._callQueriesListener);
                    Object.values(this.state.calls).forEach(function (call) {
                        return call.off(call.triggerWhenChanged);
                    });
                }
            }, {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    var _this3 = this;

                    var newCalls = callNames.filter(function (callName) {
                        var isCallUpdateRequired = callDescriptors[callName].isCallUpdateRequired;

                        return isCallUpdateRequired && isCallUpdateRequired(_this3.props, nextProps, _this3.state.calls[callName]);
                    }).reduce(function (result, callName) {
                        return _extends({}, result, _defineProperty({}, callName, _this3.buildCall(callDescriptors[callName], nextProps)));
                    }, {});

                    this._updateCalls(newCalls);
                }
            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(BaseComponent, _extends({}, this.props, this.state.calls));
                }
            }, {
                key: 'buildCall',
                value: function buildCall(callDescriptor, props) {
                    var _splitCallMethod = splitCallMethod(callDescriptor.method),
                        domainName = _splitCallMethod.domainName,
                        serviceName = _splitCallMethod.serviceName,
                        methodName = _splitCallMethod.methodName;

                    var domain = this.context.utApplication.getDomain(domainName);
                    var service = domain.getService(serviceName);
                    var serviceMethod = _auroraJavascriptUtils.assert.func(service[methodName]);

                    var requestFactory = callDescriptor.requestFactory;

                    var rawRequest = requestFactory ? requestFactory(props) : {};

                    var call = serviceMethod.call(service, rawRequest);
                    this.addCallListeners(call, callDescriptor, props);
                    return call;
                }
            }, {
                key: 'addCallListeners',
                value: function addCallListeners(call, callDescriptor, props) {
                    var _this4 = this;

                    var onSuccess = callDescriptor.onSuccess,
                        onFailure = callDescriptor.onFailure;

                    call.on(_nestedHateoas.CallEventType.SUCCEED.name, function () {
                        return onSuccess && onSuccess({ call: call, props: props });
                    });
                    call.on(_nestedHateoas.CallEventType.FAILED.name, function () {
                        return onFailure && onFailure({ call: call, props: props });
                    });

                    call.on(call.triggerWhenChanged, function () {
                        return _this4.setState({ lastUpdate: new Date() });
                    });
                }
            }, {
                key: '_callQueries',
                value: function _callQueries(method) {
                    var _this5 = this;

                    var queries = this.state.queries;

                    if (!(method in queries)) {
                        return;
                    }
                    var newCalls = queries[method].reduce(function (result, callName) {
                        return _extends({}, result, _defineProperty({}, callName, _this5.buildCall(callDescriptors[callName], _this5.props)));
                    }, {});

                    this._updateCalls(newCalls);
                }
            }, {
                key: '_updateCalls',
                value: function _updateCalls(newCalls) {
                    var _this6 = this;

                    //wait for reponse (dont clean already fetched data)
                    Promise.all(Object.values(newCalls).map(function (call) {
                        return call.promise;
                    })).then(function () {
                        return _this6.setState({
                            calls: _extends({}, _this6.state.calls, newCalls)
                        });
                    });
                }
            }]);

            return WithApplication;
        }(_react.Component);

        WithApplication.contextTypes = {
            utApplication: _propTypes2.default.object.isRequired
        };
        WithApplication.displayName = 'WithCalls(' + getDisplayName(BaseComponent) + ')';

        WithApplication.getWrappedInstance = function () {
            return BaseComponent;
        };

        return (0, _hoistNonReactStatics2.default)(WithApplication, BaseComponent);
    };
}

var callShape = _propTypes2.default.shape({
    request: _propTypes2.default.object.isRequired, // model
    response: _propTypes2.default.object.isRequired, // model
    state: _propTypes2.default.object.isRequired
});

function callProp(callNames) {
    validateCallMethodName(callNames);

    return callShape.isRequired;
}

function anyCallProp() {
    return callShape;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/withCalls.js
// module id = 1332
// module chunks = 118